<template>
  <button 
    class="customizer-header-buy-button customizer-header-buy-button-label text-center" 
    @click="handleBuyButtonClick" 
    :aria-label="translations.headerBuy"
  >
    <currency-wrapper 
      v-if="!showShareInStore" 
      class="customizer-header-buy-button-label-span" 
      :priceRaw="$store.state.buyPanel.price.string"
    >
      {{ translations.headerBuy }}
    </currency-wrapper>
    <span v-else class="customizer-header-buy-button-label-span">
      {{ translations.shareInStoreHeader }}
    </span>
  </button>
</template>

<script>

import currencyWrapper from '@/components/Globals/CurrencyWrapper'

export default {
  name: "BuyButtonLabel",
  components: {
    currencyWrapper
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    showShareInStore() {
      return this.$store.state.buyPanel.showShareInStore;
    },
    rayTracerDisabled() {
      return this.$store.state.utils.trayDisabled.swatches || this.$store.state.utils.trayDisabled.geostates;
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    }
  },
  methods: {
    closeSplashPage() {
      this.$eventBus.$emit('splash-page-background-click');
    },
    openBuyPanel() {
      if (this.rayTracerDisabled || this.isSplashModalOpen) {
        return;
      }
      if (!this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.setDataLayer();
      } else {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerTopHeader,
          eventLabel: 'Buy'
        });
      }
      this.$eventBus.$emit('buyButtonClicked');
      this.$eventBus.$emit('changeExternalHeadersVisibility', 'hide');
    },
    shareInStore() {
      if (this.rayTracerDisabled) {
        return;
      }
      const modalName = this.$store.state.utils.configuration.modals.shareInStore ? 'shareInStore' : 'shareInStoreModal';
      this.$modal.show(modalName);
    },
    handleBuyButtonClick() {
      if (this.showShareInStore) this.shareInStore();
      else if (this.isSplashModalOpen) this.closeSplashPage();
      else this.openBuyPanel();
    },
    setDataLayer() {
      const changedRecipe = this.$recipe.getComponentsSwatchApplied('deep');
      const toolsApplied = [];
      const patternMakerComponents = this.$recipe.checkForPatternMaker();
      const personalUgcComponents = this.$ugc.getComponentsWithUgcApplied(false);

      if (patternMakerComponents.length) {
        toolsApplied.push('patternmaker');
        if (personalUgcComponents.filter(component => !patternMakerComponents.includes(component)).length) {
          toolsApplied.push('ugc');
        }
      }
      else {
        if (personalUgcComponents.length) {
          toolsApplied.push('ugc');
        }
      }

      dataLayer.push({
        event: "trackEvent",
        bundleId: this.$store.state.recipe.recipe_v2.bundle_partnumber,
        silhouette: this.$store.state.utils.pdmModel,
        customTools: toolsApplied.toString(),
        eventCategory: "customs",
        eventAction: "buy cta",
        eventLabel: changedRecipe.toString()
      });
    }
  }
};
</script>
